import { render } from "./HeroiconsOutlineArrowNarrowLeft.vue?vue&type=template&id=47c1bdc2"
const script = {}

import exportComponent from "/home/nginx/domains/tools.androidrepublic.org/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineArrowNarrowLeft.vue"]])

export default __exports__